import React from "react";
import Label from "../Common/Label";
import "./ImageAndContentIns.css";

const FacebookPost: React.FC = () => {
  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <div className="header-label">
            <Label children="Best Practices" fontWeight={600} fontSize="20px" />
          </div>
          <div className="list-items mt-2">
            <ul className="custom-list">
              <li>
                <Label
                  children="Use high-resolution images to prevent blurriness."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Ensure important content is centered (avoid cropping issues)."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Use engaging captions – the first 125 characters are visible before 'See More.'"
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Use 1-3 relevant hashtags for better reach."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
              <li>
                <Label
                  children="Engage in the first hour (replying to comments boosts visibility)."
                  fontSize="14px"
                  fontWeight={400}
                />
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-6">
          <div className="header-label">
            <Label children="Restrictions " fontWeight={600} fontSize="20px" />
          </div>
          <div className="list-items mt-2">
            <div>
              <Label
                children="Image Restrictions:"
                fontWeight={400}
                fontSize="14px"
              />
              <ul>
                <li>
                  <Label
                    children="Formats: JPG, PNG"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Aspect Ratio: 1.91:1 (Landscape)"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Max File Size: 8MB"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>
              </ul>
            </div>
            <div>
              <Label
                children="Text Restrictions:"
                fontWeight={400}
                fontSize="14px"
              />
              <ul>
                <li>
                  <Label
                    children="Caption Limit: 63,206 characters"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Hashtags: No limit, but best practice is 1-3 hashtags."
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Mentions: Allowed (@username, @company)"
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>

                <li>
                  <Label
                    children="Links: Not clickable in captions; use “Link in comments” instead."
                    fontWeight={400}
                    fontSize="14px"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacebookPost;
